/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_TitleInputs */

const en_to_typescript_title = /** @type {(inputs: To_Typescript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON to TypeScript Converter`)
};

const ko_to_typescript_title = /** @type {(inputs: To_Typescript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScript 변환기`)
};

const ja_to_typescript_title = /** @type {(inputs: To_Typescript_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScript変換ツール`)
};

/**
* | output |
* | --- |
* | "JSON to TypeScript Converter" |
*
* @param {To_Typescript_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_title = /** @type {((inputs?: To_Typescript_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_title(inputs)
	if (locale === "ko") return ko_to_typescript_title(inputs)
	return ja_to_typescript_title(inputs)
});